<template>
  <head>
    <meta charset="utf-8"/>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link href="assets/images/favicon.png" rel="shortcut icon">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- Font Awesome -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"/>

    <!-- Bootstrap JS for modal functionality -->

  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">
          <!-- Page Title -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">
                  <i class="fas fa-file-invoice-dollar text-primary me-2"></i> Imprest Request
                </h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Imprest</a></li>
                    <li class="breadcrumb-item active">Request</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Imprest Request Stats -->
          <div class="row mb-4">
            <div class="col-lg-4 col-md-6">
              <div class="card mini-stats-wid h-100 border-left-primary">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2 fw-medium">Total Requests</p>
                      <h5 class="mb-0 fw-bold">{{ totalRequests }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="fas fa-file-alt"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="card mini-stats-wid h-100 border-left-warning">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2 fw-medium">Pending Requests</p>
                      <h5 class="mb-0 fw-bold">{{ pendingRequests }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="fas fa-clock"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="card mini-stats-wid h-100 border-left-success">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2 fw-medium">Total Amount</p>
                      <h5 class="mb-0 fw-bold">{{ formatPrice(totalRequestAmount) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="fas fa-money-bill-wave"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Imprest Request Form -->
          <div class="row">
            <div class="col-12">
              <div class="card shadow-sm">
                <div class="card-header bg-white">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <i class="fas me-2 font-size-18" :class="isEditing ? 'fa-edit text-warning' : 'fa-plus-circle text-primary'"></i>
                      <h5 class="card-title mb-0">{{ isEditing ? 'Edit Imprest Request' : 'Create New Imprest Request' }}</h5>
                    </div>
                    <button v-if="isEditing" @click="cancelEdit" class="btn btn-sm btn-outline-secondary">
                      <i class="fas fa-times me-1"></i> Cancel Edit
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <form @submit.prevent="submitImprestRequest" class="needs-validation" novalidate>
                    <div class="row">
                      <div class="col-md-6 mb-4">
                        <label class="form-label fw-medium" for="purpose">
                          Purpose <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="fas fa-info-circle"></i></span>
                          <input
                              id="purpose"
                              type="text"
                              class="form-control"
                              v-model="imprestRequest.purpose"
                              required
                              placeholder="Enter purpose of imprest"
                          >
                        </div>
                        <div class="form-text">Brief description of why you need this imprest</div>
                      </div>

                      <div class="col-md-6 mb-4">
                        <label class="form-label fw-medium" for="amount">
                          Amount <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="fas fa-money-bill"></i></span>
                          <input
                              id="amount"
                              type="number"
                              class="form-control"
                              v-model="imprestRequest.amount"
                              required
                              min="0"
                              placeholder="Enter imprest amount"
                          >
                          <span class="input-group-text">KES</span>
                        </div>
                        <div class="form-text">Amount requested in Kenyan Shillings</div>
                      </div>

                      <div class="col-md-6 mb-4">
                        <label class="form-label fw-medium" for="department">
                          Department <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="fas fa-building"></i></span>
                          <select
                              id="department"
                              class="form-select"
                              v-model="imprestRequest.department"
                              required
                          >
                            <option value="" disabled>Select Department</option>
                            <option v-for="dept in departments" :key="dept.departmentID" :value="dept.departmentID">
                              {{ dept.departmentName }} - Available Budget: {{dept.currency}} {{ formatPrice(dept.budget, dept.currency) }}
                            </option>
                          </select>
                        </div>
                        <div class="form-text">Select the department requesting the imprest</div>
                      </div>

                      <div class="col-md-6 mb-4">
                        <label class="form-label fw-medium" for="expectedDate">
                          Expected Date of Expenditure <span class="text-danger">*</span>
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
                          <input
                              id="expectedDate"
                              type="date"
                              class="form-control"
                              v-model="imprestRequest.expected_date"
                              required
                              :min="getTodayDate()"
                          >
                        </div>
                        <div class="form-text">When do you expect to use these funds?</div>
                      </div>

                      <div class="col-12 mb-4">
                        <label class="form-label fw-medium" for="details">
                          Additional Details
                        </label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="fas fa-align-left"></i></span>
                          <textarea
                              id="details"
                              class="form-control"
                              v-model="imprestRequest.details"
                              rows="4"
                              placeholder="Provide any additional details about this imprest request"
                          ></textarea>
                        </div>
                        <div class="form-text">Any additional information that might support your request</div>
                      </div>
                    </div>

                    <div v-if="alert.success || alert.info || alert.failed" class="alert-container mb-4 fade-in">
                      <div v-if="alert.success" class="alert alert-success d-flex align-items-center" role="alert">
                        <i class="fas fa-check-circle me-2"></i>
                        <div>{{message}}</div>
                        <button type="button" class="btn-close ms-auto" @click="clearAlerts"></button>
                      </div>

                      <div v-if="alert.info" class="alert alert-primary d-flex align-items-center" role="alert">
                        <i class="fas fa-info-circle me-2"></i>
                        <div>{{message}}</div>
                        <button type="button" class="btn-close ms-auto" @click="clearAlerts"></button>
                      </div>

                      <div v-if="alert.failed" class="alert alert-danger d-flex align-items-center" role="alert">
                        <i class="fas fa-exclamation-circle me-2"></i>
                        <div>{{message}}</div>
                        <button type="button" class="btn-close ms-auto" @click="clearAlerts"></button>
                      </div>
                    </div>

                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <button type="button" class="btn btn-light me-md-2" @click="resetForm">
                        <i class="fas fa-undo me-1"></i> Reset
                      </button>
                      <button :disabled="disabled" type="submit" class="btn btn-primary px-4">
                        <i class="fas me-1" :class="isEditing ? 'fa-save' : 'fa-paper-plane'"></i> {{isEditing ? 'Update Request' : submitLoading}}
                      </button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>

          <!-- Recent Requests Table (New Section) -->
          <div class="row mt-4">
            <div class="col-12">
              <div class="card shadow-sm">
                <div class="card-header bg-white">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <i class="fas fa-history text-primary me-2 font-size-18"></i>
                      <h5 class="card-title mb-0">Recent Imprest Requests</h5>
                    </div>
                    <button @click="getRecentRequests()" class="btn btn-sm btn-primary">
                      <i class="fas fa-sync-alt me-1"></i> Refresh
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-hover table-striped">
                      <thead class="table-light">
                      <tr>
                        <th>ID</th>
                        <th>Purpose</th>
                        <th>Department</th>
                        <th>Amount</th>
                        <th>Expected Date</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-if="!recentRequests || recentRequests.length === 0">
                        <td colspan="7" class="text-center py-4">
                          <i class="fas fa-file-alt text-muted me-2"></i> No recent imprest requests found
                        </td>
                      </tr>
                      <tr v-for="(request, index) in recentRequests" :key="index">
                        <td>{{ request.id }}</td>
                        <td>{{ request.purpose }}</td>
                        <td>{{ request.department }}</td>
                        <td>{{ formatPrice(request.amount) }}</td>
                        <td>{{ formatDate(request.expected_date) }}</td>
                        <td>
                        <span :class="getStatusBadgeClass(request.status)">
                          {{ request.status }}
                        </span>
                        </td>
                        <td>
                          <div class="btn-group btn-group-sm">
                            <button class="btn btn-light" title="View Details" @click="viewRequestDetails(request)">
                              <i class="fas fa-eye"></i>
                            </button>
                            <button v-if="request.status === 'pending'" class="btn btn-light" title="Edit Request" @click="editRequest(request)">
                              <i class="fas fa-edit"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>

  <!-- Request Details Modal -->
  <div class="modal fade" id="requestDetailsModal"  aria-labelledby="requestDetailsModalLabel" aria-hidden="true" v-if="showDetailsModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="requestDetailsModalLabel">
            <i class="fas fa-file-invoice text-primary me-2"></i>
            Imprest Request Details
          </h5>
          <button type="button"  class="btn-close" @click="showDetailsModal = false" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-if="currentRequest">
          <div class="mb-4 text-center">
            <span :class="getStatusBadgeClass(currentRequest.status)" class="badge-lg">
              {{ currentRequest.status.toUpperCase() }}
            </span>
          </div>

          <div class="card mb-3 border-0 bg-light">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <strong>Request ID:</strong>
                <span>{{ currentRequest.request_id }}</span>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <strong>Purpose:</strong>
                <span>{{ currentRequest.purpose }}</span>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <strong>Department:</strong>
                <span>{{ currentRequest.department }}</span>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <strong>Amount:</strong>
                <span>{{ formatPrice(currentRequest.amount) }}</span>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <strong>Expected Date:</strong>
                <span>{{ formatDate(currentRequest.expected_date) }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <strong class="d-block mb-2">Additional Details:</strong>
            <p class="bg-light p-3 rounded">{{ currentRequest.details || 'No additional details provided.' }}</p>
          </div>

          <div v-if="currentRequest.approvalDetails" class="mb-3">
            <strong class="d-block mb-2">Approval Information:</strong>
            <div class="bg-light p-3 rounded">
              <div v-if="currentRequest.approvalDetails.approvedBy" class="d-flex justify-content-between mb-2">
                <span>Approved By:</span>
                <span>{{ currentRequest.approvalDetails.approvedBy }}</span>
              </div>
              <div v-if="currentRequest.approvalDetails.approvalDate" class="d-flex justify-content-between mb-2">
                <span>Approval Date:</span>
                <span>{{ formatDate(currentRequest.approvalDetails.approvalDate) }}</span>
              </div>
              <div v-if="currentRequest.approvalDetails.comments" class="mt-2">
                <span class="d-block">Comments:</span>
                <p class="mt-1 mb-0">{{ currentRequest.approvalDetails.comments }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="showDetailsModal = false">Close</button>
          <button v-if="currentRequest && currentRequest.status === 'pending'" type="button" class="btn btn-primary" @click="editRequest(currentRequest); showDetailsModal = false;">
            <i class="fas fa-edit me-1"></i> Edit Request
          </button>
        </div>
      </div>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import {authUrl, execute} from "@/api";
import NavigationBar from "@/components/Navigation.vue";

export default {
  name: 'ImprestRequest',
  components: {NavigationBar},
  data() {
    return {
      alert:{
        success: false,
        info: false,
        failed: false
      },
      message: null,
      submitLoading: "Submit Request",
      loading: false,
      disabled: false,
      isEditing: false,
      editingRequestId: null,
      showDetailsModal: false,
      currentRequest: null,
      totalRequests: 12,
      pendingRequests: 3,
      totalRequestAmount: 250000,
      departments: [{
        id: "20",
        departmentName: "Agriculture, Livestock, and Fisheries",
        location: "Agriculture Office",
        manager: "Daniel Kipchumba",
        description: "Supports farmers, livestock keepers, and fisheries.",
        budget: "40000000",
        createdAt: "2025-03-10 18:38:07",
        updatedAt: "2025-03-10 18:38:07",
        departmentID: "DEP004",
        currency: "KES"
      }],
      imprestRequest: {
        purpose: '',
        amount: null,
        department: '',
        expected_date: '',
        details: ''
      },
      recentRequests: [
        {
          request_id: 'IMP-2025-001',
          purpose: 'Field Visit to Nakuru County',
          department: 'Agriculture, Livestock, and Fisheries',
          amount: 25000,
          expected_date: '2025-03-20',
          status: 'pending',
          details: 'Visit to inspect agricultural projects and meet with local farmers'
        },
        {
          request_id: 'IMP-2025-002',
          purpose: 'Office Supplies Procurement',
          department: 'Agriculture, Livestock, and Fisheries',
          amount: 15000,
          expected_date: '2025-03-18',
          status: 'approved',
          details: 'Purchase of stationery and office materials'
        },
        {
          request_id: 'IMP-2025-003',
          purpose: 'Farmer Training Workshop',
          department: 'Agriculture, Livestock, and Fisheries',
          amount: 45000,
          expected_date: '2025-03-25',
          status: 'rejected',
          details: 'Training for local farmers on modern farming techniques'
        }
      ]
    }
  },
  mounted() {
    this.getDepartments();
    this.getRecentRequests();
  },
  methods: {
    formatPrice(value, currency = 'KES') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
      }).format(value);
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    },
    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getStatusBadgeClass(status) {
      const statusLower = status.toLowerCase();
      switch(statusLower) {
        case 'approved':
          return 'badge bg-success';
        case 'pending':
          return 'badge bg-warning';
        case 'rejected':
          return 'badge bg-danger';
        default:
          return 'badge bg-secondary';
      }
    },
    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
      this.message = null;
    },
    resetForm() {
      this.imprestRequest = {
        purpose: '',
        amount: null,
        department: '',
        expected_date: '',
        details: ''
      };
      this.clearAlerts();
      this.isEditing = false;
      this.editingRequestId = null;
    },

    editRequest(request) {
      // Switch to editing mode
      this.isEditing = true;
      this.editingRequestId = request.request_id;

      // Populate form with request data
      this.imprestRequest = {
        purpose: request.purpose,
        amount: request.amount,
        department: this.getDepartmentIdByName(request.department),
        expected_date: request.expected_date,
        details: request.details || ''
      };

      // Scroll to form
      this.$nextTick(() => {
        document.querySelector('.card.shadow-sm').scrollIntoView({ behavior: 'smooth' });
      });
    },

    cancelEdit() {
      if (confirm('Are you sure you want to cancel editing? Any unsaved changes will be lost.')) {
        this.resetForm();
      }
    },

    getDepartmentIdByName(departmentName) {
      const department = this.departments.find(dept => dept.departmentName === departmentName);
      return department ? department.departmentID : '';
    },
    submitImprestRequest() {
      const isUpdate = this.isEditing;
      this.submitLoading = isUpdate ? "Updating..." : "Submitting...";
      this.message = isUpdate ? "Updating your imprest request..." : "Processing your imprest request...";
      this.alert.info = true;
      this.alert.success = false;
      this.alert.failed = false;
      this.disabled = true;

      const data = new FormData();
      if (isUpdate) {
        data.append("function", "updateImprestRequest");
        data.append("requestId", this.editingRequestId);
      } else {
        data.append("function", "createImprestRequest");
      }
      data.append("imprestRequest", JSON.stringify(this.imprestRequest));

      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.submitLoading = "Submit Request";
              this.message = res.data.message || (isUpdate ? "Request updated successfully!" : "Request submitted successfully!");
              this.alert.success = true;
              this.alert.info = false;
              this.alert.failed = false;

              // Reset form and editing state
              this.resetForm();
              this.isEditing = false;
              this.editingRequestId = null;

              // Refresh recent requests list
              this.getRecentRequests();

              // Set timeout to clear success message
              setTimeout(() => {
                this.clearAlerts();
              }, 5000);

            } else {
              this.disabled = false;
              this.submitLoading = "Submit Request";
              this.message = res.data.message;
              this.alert.success = false;
              this.alert.info = false;
              this.alert.failed = true;
            }
          })
          .catch((e) => {
            this.disabled = false;
            this.submitLoading = "Submit Request";
            this.message = e.message || "An error occurred. Please try again.";
            this.alert.success = false;
            this.alert.info = false;
            this.alert.failed = true;
          });
    },
    getDepartments() {
      this.departments.splice(0)
      const data = new FormData();
      data.append("function", "getDepartments");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.departments = res.data.data.departments
            } else {
              this.message = res.data.message;
              this.alert.failed = true;
            }
          })
          .catch((e) => {
            this.message = e.message || "Failed to load departments.";
            this.alert.failed = true;
          });
    },
    getRecentRequests() {
      // Call API to get recent requests
      console.log("Fetching recent requests...");

      const data = new FormData();
      data.append("function", "getRecentImprestRequests");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.recentRequests = res.data.data.recentRequests;
            } else {
              console.error("Error fetching recent requests:", res.data.message);
            }
          })
          .catch((e) => {
            console.error("Error fetching recent requests:", e);
          });
    },



    viewRequestDetails(request) {
      // Get full request details (in a real app, you might fetch more details from API)
      this.currentRequest = { ...request };

      // Add mock approval details if the request is approved or rejected
      if (request.status === 'approved') {
        this.currentRequest.approvalDetails = {
          approvedBy: 'John Doe',
          approvalDate: '2025-03-12',
          comments: 'Request approved for the upcoming field activities.'
        };
      } else if (request.status === 'rejected') {
        this.currentRequest.approvalDetails = {
          approvedBy: 'Jane Smith',
          approvalDate: '2025-03-13',
          comments: 'Request rejected due to insufficient budget allocation. Please revise and resubmit.'
        };
      }

      // Show the modal
      this.showDetailsModal = true;

      // Initialize Bootstrap modal (in a real implementation)
      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('requestDetailsModal'));
        modal.show();
      });
    }
  }
}
</script>

<style scoped>
.border-left-primary {
  border-left: 4px solid #4e73df;
}
.border-left-success {
  border-left: 4px solid #1cc88a;
}
.border-left-warning {
  border-left: 4px solid #f6c23e;
}
.fade-in {
  animation: fadeIn 0.5s;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.card {
  transition: all 0.3s ease;
}
.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.form-control:focus, .form-select:focus {
  border-color: #4e73df;
  box-shadow: 0 0 0 0.25rem rgba(78, 115, 223, 0.25);
}

.badge-lg {
  font-size: 1rem;
  padding: 0.5rem 1rem;
}

.modal-content {
  border-radius: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

#requestDetailsModal .card {
  transition: none;
}

#requestDetailsModal .card:hover {
  transform: none;
  box-shadow: none;
}
</style>